var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-2 shadow"},[_c('div',{staticClass:"card-header fw-bold"},[_c('b-skeleton',{attrs:{"width":"100%"}})],1),_c('ul',{staticClass:"list-group list-group-flush"},[_c('li',{staticClass:"list-group-item"},[_c('b-skeleton',{attrs:{"count":6}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }